import type {
  CommercialCustomer,
  CommercialCustomersResult,
} from "@/core/dashboard/entities/CommercialCustomer";

/** Raw branch sub-object of CustomerListResponse. */
interface ApiBranchResponse {
  name?: string | null;
}

/** Raw advisor sub-object of CustomerListResponse. */
interface ApiAdvisorResponse {
  name?: string | null;
}

/** Raw CustomerListResponse item (snake_case fields per the backend DTO). */
export interface ApiCommercialCustomerItem {
  id: string;
  businessKey: string;
  full_name?: string | null;
  customer_code?: string | null;
  branch?: ApiBranchResponse | null;
  advisor?: ApiAdvisorResponse | null;
  type?: string | null;
  maj?: string | null;
  status?: string | null;
  riskLevel?: string | null;
  nbr_compte?: number | null;
  kyc?: string | null;
  total_balance?: number | null;
  createdTimestamp?: string | null;
}

/** Raw PaginatedResponse<CustomerListResponse>. */
export interface ApiCommercialCustomersResponse {
  items?: ApiCommercialCustomerItem[] | null;
  totalElements?: number | null;
}

export default class CommercialCustomersMapper {
  static toDomainItem(item: ApiCommercialCustomerItem): CommercialCustomer {
    return {
      id: item.id,
      businessKey: item.businessKey,
      fullName: item.full_name ?? "",
      customerCode: item.customer_code ?? null,
      branchName: item.branch?.name ?? null,
      advisorName: item.advisor?.name ?? null,
      type: item.type ?? null,
      updatedAt: item.maj ?? null,
      status: item.status ?? null,
      riskLevel: item.riskLevel ?? null,
      accountCount: item.nbr_compte ?? null,
      kyc: item.kyc ?? null,
      totalBalance: item.total_balance ?? null,
      createdTimestamp: item.createdTimestamp ?? null,
    };
  }

  static toDomain(
    api: ApiCommercialCustomersResponse,
  ): CommercialCustomersResult {
    const items = (api.items ?? []).map((it) => this.toDomainItem(it));
    return { items, totalElements: api.totalElements ?? items.length };
  }
}
